<template>
  <div class="small-ocean">
    <b-container class="help">
      <b-row>
        <b-col cols="2">
        </b-col>
        <b-col cols="8">
      <h1>How to run our games</h1>
      <p>Most of our games require the Flash plugin. If you can see a rocket ship animating in the box below then your computer is good to go.</p>
    
      <iframe src="http://localhost:8081/games/flashtest.html" width="320" height="240" frameBorder="0"></iframe>

      <p>If you do not see the animation simply visit the Flash installation page to <a href="https://get.adobe.com/flashplayer/">Get the Flash Player</a></p>
      <p>Once you have successfully installed the Flash Player you will be able to play all the games on our site.</p>

      <div @click="goBack()">Go Back</div>
    </b-col>
  </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'About',
  props: {
    msg: String
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ocean {
  background-image:url("../assets/img/world/ocean.jpg");
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  min-height:300px;
  margin-top:40px;
  height: 100%;
}
.small-ocean {
  background-image:url("../assets/img/2016/water_banner.png");
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  margin-top: 0px;
  padding-top: 0px;
  min-height:300px;
  height: 800px;
}
.help {
  margin-top: 100px;
}
</style>
